import getMetaTagValue from '../../lib/getMetaTagValue';
import { DEVELOPMENT } from '../../lib/env/enum';

const environment = getMetaTagValue('environment');

const inDevEnvironment = environment === DEVELOPMENT;

if (inDevEnvironment && typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__ === 'object') {
    window.__REACT_DEVTOOLS_GLOBAL_HOOK__.inject = function() {/**/};
}
